import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { AppDataContext } from '~/contexts/AppDataContext';
import {
  getCSSHeightLgFactor,
  getCSSHeightMdFactor,
  getCSSHeightSmFactor,
} from '~/utilities/getCSS';
import { getScreenSizeObject } from '~/utilities/getScreenSizeObject';

const logoClasses = cva(
  'inline-flex items-center items-start duration-200 mr-5',
  {
    variants: {
      heightSm: getCSSHeightSmFactor(),
      heightMd: getCSSHeightMdFactor(),
      heightLg: getCSSHeightLgFactor(),
    },
  }
);

export default component$((): JSX.Element => {
  const {
    payloadToSSR: {
      layout: { header },
    },
    themeComponents,
  } = useContext(AppDataContext);

  return (
    <a
      class={logoClasses({
        ...getScreenSizeObject(
          themeComponents.header,
          'firstRowLogoHeightIn',
          'Screen',
          'height'
        ),
      })}
      href={header.secondaryLogo?.value.url}
    >
      <img
        class='h-full'
        width={undefined}
        height={undefined}
        src={`data:image/svg+xml,${encodeURIComponent(header.secondaryLogo?.value.src ?? '')}`}
        alt={header.secondaryLogo?.value.alt}
      />
    </a>
  );
});
